import type { CreditGateData } from '../types';

const CREDIT_GATE_SESSION_KEY = 'studio-ai-credit-gate';

export function readStoredCreditGate(): CreditGateData | null {
    if (typeof window === 'undefined') return null;
    try {
        const raw = sessionStorage.getItem(CREDIT_GATE_SESSION_KEY);
        return raw ? (JSON.parse(raw) as CreditGateData) : null;
    } catch {
        return null;
    }
}

export function writeStoredCreditGate(data: CreditGateData | null): void {
    if (typeof window === 'undefined') return;
    if (data) {
        sessionStorage.setItem(CREDIT_GATE_SESSION_KEY, JSON.stringify(data));
    } else {
        sessionStorage.removeItem(CREDIT_GATE_SESSION_KEY);
    }
}
